module.exports = __webpack_public_path__ + "img/blue heart.036e1551.png";